import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProgressComponent from "../../components/general/ProgressComponent";
import eventDel from "../../assets/images/icons/eventDel.svg";
import { BASE_URL, GET_ALL_STAFF_MEMBERS_URL, REMOVE_STAFF_MEMBERS_URL } from "../../env";
import { hasAnyPermissions } from "../../permission_advance/PermissionColumn";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  getRecords,
  isSuccess,
  filterColumns,
  deleteRecords,
  filterRowsByProperty,
  displayEnumProperty,
  filterArrayBySearchTerm,
  toastErrorMessages,
  formateDate,
  catchAsync,
  calculateHours,
  toastSuccessMessages,
} from "../../helper/helper";

import ProtectedComponent from "../../permissions/ProtectedComponent";
import { permissions } from "../../permissions/roles";
import useColumnsWithPermission from "../../permissions/useColumnsWithPermission";
import moment from "moment/moment";
import PermissionWrapper from "../../permission_advance/PermissionWrapper";
import UpdateArchiveData from "./archieved_staff/UpdateArchiveData";

function StaffRecordsGroup({ actionButtonsComponent }) {
  const staffLevel = Number(localStorage.getItem("staffLevel")) || 0;
  const staffPermissionName = JSON.parse(localStorage.getItem("staffPermissionName")) || "";
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [userData, setUserData] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  // console.log("🚀 ~ StaffRecordsGroup ~ filteredRows:", filteredRows)
  const [isLoading, setIsLoading] = useState(true);
  const [isPbsPlans, setIsPbsPlans] = useState(false);

  const [staffMemberData, setStaffMemberData] = useState({
    id: "",
    active: false
  });

  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);

  const apiQuery = {
    sortproperty: "createdAt",
    sortorder: -1,
    offset: 0,
    query: {
      critarion: { active: true },
    },
  };


  const [showDeletePbsPlans, setShowDeletePbsPlans] = useState(false);
  const subModalDeletePbsPlans = (delStaffMemberId) => {
    setStaffMemberData({ id: delStaffMemberId, active: false });
    setShowDeletePbsPlans(!showDeletePbsPlans);
    fetchAllRecords();
  };

  const processFetchRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      // setIsToastStaffRecords(true);
      toastErrorMessages(toast?.error, data?.message, "", 1000, 1000);
    } else if (method === "get" && data?.status === isSuccess) {
      // staffLevel
      const isPayrollStaff = staffPermissionName === "Payroll Staff";

      const staffMembers = isPayrollStaff
        ? data?.data?.staffMembers // If "Payroll Staff", return all staff members
        : data?.data?.staffMembers?.filter((item) =>
          item?.user?.staffRoles?.some((role) => role?.level > staffLevel)
        );
      // console.log("🚀 ~ processFetchRecords ~ staffMembers:", staffMembers)
      const filteredRows = filterRowsByProperty(
        staffMembers,
        (row) => row?.user?.name
      );
      setUserData(filteredRows);
      setFilteredRows(filteredRows);
      setIsLoading(false);
    } else if (method === "delete" && data?.status === isSuccess) {
      toastSuccessMessages(toast.success, data?.message, "", 500, 500);
      setTimeout(() => {
        setIsPbsPlans(false);
      }, 2000);
    }
  };

  const fetchAllRecords = catchAsync(async (req, res) => {
    const response = await getRecords(GET_ALL_STAFF_MEMBERS_URL, apiQuery);

    processFetchRecords("get", response);
  });

  useEffect(() => {
    fetchAllRecords();
  }, []);

  const handleSearch = (e) => {
    const searchVal = e?.target?.value;
    setSearch(searchVal);
    if (searchVal !== "") {
      const lowercaseSearch = searchVal?.toLowerCase();
      const filteredRecords = filterArrayBySearchTerm(
        userData,
        lowercaseSearch,
        (record) => record?.user?.name?.toLowerCase()
      );
      setFilteredRows(filteredRecords);
    } else {
      setFilteredRows(userData);
    }
  };

  const handleRowClickStaffMember = (e, row) => {
    e.preventDefault();
    navigate("/staff-profile", { state: { userId: row } });
  };

  const handleTableRowClick = (row) => {
    navigate("/staff-profile", { state: { userId: row } });
  };
  const columns = [
    {
      name: "#",
      selector: (row, index) => (
        <span onClick={(e) => handleRowClickStaffMember(e, row)}>
          {index + 1}
        </span>
      ),
      width: "5%",
      center: true,
    },
    {
      name: "Name",
      selector: (row) => {
        return (
          <span
            className="usersNameInfo"
            onClick={(e) => handleRowClickStaffMember(e, row)}
          >
            <span className="userImage">
              <img
                src={`${BASE_URL}${row?.user?.profile_picture_url}`}
                alt={row?.name}
              />
            </span>
            <span className="userInfo">
              <span className="nameBlock">{`${row?.user?.name && row?.user?.name}`}{" "}{`${row?.lastName !== null && row?.lastName !== undefined ? row?.lastName : ""}`}</span>
              {
                row?.archiveDate ? (
                  <>
                    <span className="nameBlock text-danger"><small className="fw-400">Archive Date: {moment(row?.archiveDate).format("DD-MM-YYYY")}</small></span></>
                ) : ("")
              }

            </span>

          </span>
        );
      },
    },
    {
      name: "Manager",
      selector: (row) => {
        return (
          <span onClick={(e) => handleRowClickStaffMember(e, row)}>
            {row?.managerId?.name}
          </span>
        );
      },
      width: "15%",
    },
    {
      name: "Role Permissions",
      selector: (row) => {
        const staffDesignation = displayEnumProperty("staffDesignation", row?.staffDesignation);
        return (
          <span onClick={(e) => handleRowClickStaffMember(e, row)}>
            {row?.user?.staffRoles.map((item, index) => (
              <span key={index}>
                {item?.permissionName} <br />
              </span>
            ))}
          </span>
        );
      },
      width: "15%",
      wrap: true
    },
    {
      name: "Email dddd",
      selector: (row) => {
        return (
          <a
            href={`mailto:${row?.user?.email}`}
            className="blackColor"
            onClick={(e) => handleRowClickStaffMember(e, row)}
          >
            {row?.user?.email}
          </a>
        );
      },
      width: "15%",
    },
    {
      name: "Contact No.",
      selector: (row) => {
        return (
          <a
            href={`tel:${row?.user?.phoneNumber}`}
            className="blackColor"
            onClick={(e) => handleRowClickStaffMember(e, row)}
          >
            {row?.user?.phoneNumber}
          </a>
        );
      },
      width: "15%",
    },
    ...(hasAnyPermissions(["delete"], "Staff")
      ? [
        {
          name: "Action",
          selector: (row) => {
            return (
              <div className="actionColumns">
                <PermissionWrapper title="Staff" action="delete">
                  <span
                    onClick={() => {
                      subModalArchiveDateUpdate(row);
                    }}
                  >
                    <img src={eventDel} alt="eventDel" title="Archive" />
                  </span>
                </PermissionWrapper>
                {/* <PermissionWrapper title="Staff" action="delete">
                  <span
                    className="delete"
                    onClick={() => {
                      subModalDeletePbsPlans(row?._id);
                    }}
                  >
                    <img src={eventDel} alt="Delete" title="Delete" />
                  </span>
                </PermissionWrapper> */}
              </div>
            );
          },
          width: "10%",
          center: true,
        },
      ]
      : []),
  ];

  const filteredColumns = filterColumns(columns, (column) => column !== null);


  // Delete PbsPlans records
  const deleteRecord = catchAsync(async (req, res) => {
    setIsSubmitButtonClicked(true);
    if (staffMemberData !== "") {
      const response = await deleteRecords(
        REMOVE_STAFF_MEMBERS_URL,
        staffMemberData
      );

      setIsPbsPlans(true);
      processFetchRecords("delete", response);
      fetchAllRecords();
      setIsSubmitButtonClicked(false);
      setShowDeletePbsPlans(!showDeletePbsPlans);
    } else {
      setShowDeletePbsPlans(!showDeletePbsPlans);
      setIsSubmitButtonClicked(false);
      setIsPbsPlans(true);
      toastErrorMessages(toast.error, "Unable to remove", "", 1000);
    }
  });
  useEffect(() => {
    setTimeout(() => {
      setIsPbsPlans(false);
    }, 2000);
  }, [isPbsPlans])


  //Archive user
  //Update Archive Date
  const [archiveDate, setArchiveDate] = useState();
  const [showArchiveDateUpdate, setShowArchiveDateUpdate] = useState(false);
  const subModalArchiveDateUpdate = (details) => {
    setArchiveDate({ staffMemberid: details?.id, archiveDate: details?.archiveDate });
    fetchAllRecords();
    setShowArchiveDateUpdate(!showArchiveDateUpdate);
  };

  return (
    <>
      <div className="mainContent">
        <div className="dataTableWrapper staffRecordsGroupsTable">
          <DataTable
            className="maxWidthTable"
            columns={filteredColumns}
            data={filteredRows}
            pagination
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            paginationPerPage={10}
            fixedHeader
            fixedHeaderScrollHeight="520px"
            highlightOnHover
            actions={
              <>
                <div className="buttonWrap">
                  {
                    actionButtonsComponent && (
                      <>
                        <PermissionWrapper title="Super Admin" action="view">
                          <Link to="/archived-staff-records" className="btn btn-sm btn-outline-primary">
                            Archived Staff Members
                          </Link>
                        </PermissionWrapper>
                        <PermissionWrapper title="Staff" action="update">
                          {" "}
                          <Link to="/profile-update-requests" className="btn btn-sm btn-outline-success">
                            Profile Update Requests
                          </Link>
                        </PermissionWrapper>

                        <PermissionWrapper title="Staff" action="create">
                          {" "}
                          <Link to="/add-new-staff" className="btn btn-sm btn-primary">
                            Add New
                          </Link>
                        </PermissionWrapper>
                      </>
                    )
                  }
                </div>
              </>
            }
            responsive={true}
            subHeader={true}
            subHeaderComponent={
              <div className="searchContainer">
                <div className="searchTextBox">
                  <input
                    type="text"
                    placeholder="Type your search"
                    value={search}
                    onChange={handleSearch}
                  />
                </div>
              </div>
            }
            subHeaderAlign="left"
            subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
            progressPending={isLoading}
            progressComponent={<ProgressComponent />}
            onRowClicked={handleTableRowClick}
          />
        </div>
      </div>
      {/* Delete Rota Stock */}

      <Modal
        show={showDeletePbsPlans}
        onHide={subModalDeletePbsPlans}
        className="ftcModalPopup confirmationPopup deletionConfirmation"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="editBlockContent text-center">
            <img src={eventDel} alt={eventDel} />
            <p>Are you sure you want to archive this user?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {isSubmitButtonClicked ? (
            <Button className="btn-sm" variant="danger" disabled>
              Loading...
            </Button>
          ) : (
            <Button className="btn-sm" variant="danger" onClick={deleteRecord}>
              Yes
            </Button>
          )}
          <Button
            className="btn-sm"
            variant="outline-secondary"
            onClick={subModalDeletePbsPlans}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Archive Modal Popup */}
      <Modal
        show={showArchiveDateUpdate}
        onHide={subModalArchiveDateUpdate}
        className="ftcModalPopup medicineInventoryStock"
      >
        <Modal.Header closeButton style={{ background: "#ff0000" }}>
          <Modal.Title>Archieve User</Modal.Title>
        </Modal.Header>
        <Modal.Body className="rosterPopup">
          <UpdateArchiveData
            staffMemberDetail={archiveDate}
            subModalArchiveStaff={subModalArchiveDateUpdate}
            futureArchive={true}
          />
        </Modal.Body>
      </Modal>

      {isPbsPlans && <ToastContainer />}
    </>
  );
}

export default StaffRecordsGroup;
